import { render, staticRenderFns } from "./kefu.vue?vue&type=template&id=1fa94479&scoped=true&"
import script from "./kefu.vue?vue&type=script&lang=js&"
export * from "./kefu.vue?vue&type=script&lang=js&"
import style0 from "./kefu.vue?vue&type=style&index=0&id=1fa94479&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa94479",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa94479')) {
      api.createRecord('1fa94479', component.options)
    } else {
      api.reload('1fa94479', component.options)
    }
    module.hot.accept("./kefu.vue?vue&type=template&id=1fa94479&scoped=true&", function () {
      api.rerender('1fa94479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/person/kefu.vue"
export default component.exports